var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-audio-native',{ref:"audioNative",attrs:{"showDownload":false,"hint":"加载中","size":"large","waitBuffer":false,"showMuted":false,"url":_vm._f("withAudio")(_vm.audioSrc)}})}
var staticRenderFns = []

export { render, staticRenderFns }